let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
console.log(items);
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".custom-varaint-withjs li");
  const baseball = document.querySelector(
    "section#product-provelocity-power-training-bat"
  );
  const softball = document.querySelector(
    "section#product-the-provelocity™-softball-bat"
  );

  listItems.forEach((item) => {
    item.addEventListener("click", function () {
      const text = this.textContent.toLowerCase();
      console.log(text);
      if (text == "baseball") {
        baseball.style.display = "block";
        softball.style.display = "none";
      } else {
        baseball.style.display = "none";
        softball.style.display = "block";
      }
    });
  });
});

// Function to initialize counters
function setupCounters() {
    const counters = document.querySelectorAll('.counter'); // Select all counter elements
    counters.forEach(counter => {
        const maxCount = parseInt(counter.dataset.count); // Maximum count value from data attribute
        let count = 0; // Initialize count at 0
      const interval = 3000 / maxCount;

        function updateCounter() {
            if (count <= maxCount) {
                counter.textContent = count++; // Increment and update display
            }
            if (count > maxCount) {
                setTimeout(() => { // Pause for 5 seconds after reaching max count
                    count = 0; // Reset count to 0
                    counter.textContent = count; // Update display to 0
                    setTimeout(updateCounter, interval); // Continue counting after 1 second
                }, 5000);
            } else {
                setTimeout(updateCounter, interval); // Update count every second
            }
        }

        setTimeout(updateCounter, interval); // Start counting 1 second after page loads
    });
}

// Initialize all counters on page load
window.onload = setupCounters;

